module.exports = {"api_addr":"https://vezljivostni.cjvt.si/service"}


//////////////////
// WEBPACK FOOTER
// ./config/config.json
// module id = J/Fn
// module chunks = 1